<template>
    <section class="container">
        <h2 class="text-center"><span class="text-primary">3</span> Étapes pour nous rejoindre</h2>
        <div id="join-steps" class="timeline">
            <div class="timeline-item visible">
                <div class="dot"></div>
                <div class="t-progress"></div>
                <div class="t-item-content left">
                    <h3>1. Dénicher</h3>
                    <p class="text-left text-sm">Chercher-vous à jouer après le travail, à gérer votre équipe de dimanche ou à
                        venger sur le terrain de football?</p>
                    <p class="text-left text-sm">Découvrez le plus vaste réseau d'installations sportives en Tunisie. Il suffit
                        d'indiquer votre emplacement, de sélectionner votre terrain et de cliquer sur le bouton
                        recherche.</p>
                </div>
                <div class="image">
                    <img src="@/assets/img/step1.jpg" alt="Step 1">
                </div>
            </div>
            <div class="timeline-item visible">
                <div class="dot"></div>
                <div class="t-progress"></div>
                <div class="image">
                    <img src="@/assets/img/step2.jpg" alt="Step 2">
                </div>
                <div class="t-item-content right">
                    <h3>2. Réserver</h3>
                    <p class="text-sm">Une fois que vous avez déniché la présentation idéale. Utilisez le formulaire de demande pour
                        vous mettre en relation avec le lieu afin de faire une réservation en ligne.</p>
                    <p class="text-sm">Nous collaborons avec les meilleures infrastructures sportives en Tunisie pour faciliter
                        l'organisation de vos activités sportives.</p>
                </div>
            </div>

            <div class="timeline-item visible">
                <div class="dot"></div>
                <div class="t-item-content left">
                    <h3>3. Jouer</h3>
                    <p class="text-sm text-left">Vous êtes le héro, vous avez déniché un terrain de jeu incroyable, réservé sans
                        effort et maintenant, il est temps de jouer.</p>
                    <p class="text-sm text-left">Le décor est planté pour votre affrontement épique, où les rêves peuvent se
                        réaliser ou être anéantis. La douleur est éphémère, mais la victoire est éternelle. Ne laissez
                        rien au hasard.</p>
                </div>
                <div class="image">
                    <img src="@/assets/img/step3.jpg" alt="Step 3">
                </div>
            </div>

        </div>
    </section>
</template>
<style>

.timeline {
    position: relative;
    width: 80%;
    max-width: 900px;
    margin: 50px auto 100px;
}

.timeline-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap; /* Allow stacking */
    margin: 50px 0;
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    position: relative;
}

.dot {
    width: 20px;
    height: 20px;
    margin: 20px 0;
    background: #d7b345;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.t-progress {
    position: absolute;
    z-index: -1;
    left: 50%;
    top: 50%;
    width: 4px;
    height: 0;
    background: #d7b345;
    transition: height 1.2s ease-out;
    transform: translateX(-50%);
}

.t-item-content {
    width: 40%;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.image {
    width: 40%;
    display: flex;
    justify-content: center;
}

.image img {
    width: 100%;
    max-width: 150px;
    height: auto;
    border-radius: 50%;
}

.left {
    text-align: right;
}

.right {
    text-align: left;
}

/* Active State */
.visible {
    opacity: 1;
    transform: translateY(0);
}

/* Mobile Styles */
@media screen and (max-width: 768px) {
    .timeline {
        width: 90%;
        max-width: 400px;
    }
    .timeline-item {
        display: flex;
        flex-direction: column; /* Stack elements vertically */
        align-items: center;
        text-align: center;
    }
    
    .t-item-content {
        order: -1; /* Moves content above the dot */
        width: 90%;
    }
    
    .dot {
        position: relative;
        left: unset;
        transform: translateX(0);
        order: 0; /* Keeps the dot in position */
    }

    .left {
        text-align: left;
    }
    
    .t-progress {
        position: absolute;
        height: 0;
        background: #d7b345;
        transition: height 1.2s ease-out;
        transform: translateX(-30%);
    }
    
    .image {
        order: 1; /* Moves the image below the dot */
        width: 100%;
    }
    
    .image img {
        height: auto;
    }
}
</style>
<script>

export default {
    mounted() {
        $(document).ready(function () {
            const items = $(".timeline-item");
            const progressBars = $(".t-progress");
        
            $(window).on("scroll", function () {
                items.each(function (index) {
                    const itemTop = $(this).offset().top;
                    const windowBottom = $(window).scrollTop() + $(window).height();
                    
                    if (windowBottom > itemTop) {
                        $(this).addClass("visible");
        
                        if (index > 0) {
                            const prevDot = items.eq(index - 1).find(".dot").offset().top;
                            const currentDot = $(this).find(".dot").offset().top;
        
                            progressBars.eq(index - 1).css({
                                height: (currentDot - prevDot) + "px"
                            });
        
                            if ($(window).width() <= 768) {
                                const contentHeight = items.eq(index - 1).find(".t-item-content").height() + 20 + 50;
                                progressBars.eq(index - 1).css({
                                    top: contentHeight + "px"
                                });
                            }
                        }
                    }
                });
            });
        });
    },
}
</script>